<template>
  <div class="case-type-wrap">
    <div class="wrap">
        <div class="center">
            <div class="center-content">
                <div class="left">
                    <xl-scrollbar>
                        <div class="types">
                            <title-name class="title">{{$t('design.case.selectProduct') || '选择服务'}}</title-name>
                            <div class="type-list">
                                <div v-for="item in typeList" :key="item.productType" 
                                    class="item" 
                                    :class="activeTypeItem.productType === item.productType ? 'item-active' : ''" 
                                    @click="onTyle(item)">
                                    <div class="img-wrap"><img :src="$getCdnUrl(item.image)" alt=""/></div>
                                    <span class="type-name">{{ item.typeName }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="goods-wrap">
                            <div class="goods-list">
                                <goods-card v-for="(item, index) in (activeTypeItem.productList || []) " :key="index"
                                    :class="activeCommodityId === item.productID ? 'goods-active' : ''" :info="item" @click="onGoodsClick(item)">
                                </goods-card>
                            </div>
                        </div>
                    </xl-scrollbar>
                </div>
                <div class="right">
                    <title-name>{{$t('design.case.productdesc') || '产品介绍'}}</title-name>
                    <div class="description" v-if="activeCommodity.productRemark">
                        <div class="tlt">·{{$t('design.orderDetail.designDescription') || '设计描述'}}</div>
                        <div class="desc">{{ activeCommodity.productRemark }}</div>
                        <div class="tlt">·{{$t('design.orderDetail.deliveryContent') || '交付内容'}}</div>
                        <div class="desc">{{ activeCommodity.productContent }}</div>
                    </div>
                    <div class="description" v-if="!activeCommodity.productRemark">
                        <noData>
                            <template #text><div style="min-width:130px;">{{$t('design.caseType.noChose') || '请选择设计服务类型'}}</div></template>
                        </noData>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="urgent-wrap">
                <div class="soon-wrap" v-show="activeCommodity.isUrgent">
                    <i class="iconfont icon-zhuyi"></i>
                    <span class="tlt urgent-tip">{{$t('design.case.urgentGoodsTip') || '当前商品支持加急，是否开启'}}</span>
                    <xl-switch v-model="needSoon" :disabled="soonDisabled"></xl-switch>
                </div>
                <div class="detail" v-show="activeCommodity.isUrgent">
                    <div class="item">
                        <span class="tlt">{{$t('design.case.urgentServiceFee') || '加急服务费'}}</span>
                        <span class="value">{{ formatPrice(activeCommodity.urgentPrice) }} {{ activeCommodity.currency }}/{{ unitMap[activeCommodity.chargeUnit] }}<span v-if="activeCommodity.urgentPoints">{{ $lang() === 'en-us' ? ' ' + $t('design.or') + ' ' : $t('design.or')}}{{$t('design.point.pointNum', { point: activeCommodity.urgentPoints }) }}/{{ unitMap[activeCommodity.chargeUnit] }}</span></span>
                    </div>
                    <div class="item">
                        <span class="tlt">{{$t('design.case.urgentDateRange') || "可以加急时间段"}}</span>
                        <span class="value">{{ soonStartTime }}-{{ soonEndTime }}</span>
                    </div>
                    <div class="item">
                        <span class="tlt">{{$t('design.orderDetail.leadTime') || "预计交付周期"}}</span>
                        <!-- <span class="value">{{ activeCommodity.urgentDeliveryDay}}{{timeMap[activeCommodity.urgentDeliveryUnit]}}</span> -->
                        <span class="value">{{ $timeUnit( $lang(), activeCommodity.urgentDeliveryUnit, activeCommodity.urgentDeliveryDay ) }}</span>
                    </div>
                </div>
            </div>
            <xl-button type="primary" @click="onNext" :loading="btnLoading">{{$t('design.goNext') || "下一步"}}</xl-button>
        </div>
    </div>
  </div>
</template>

<script setup>
// 选择设计类型
import { $lang, $getLocalStorage } from '@shining3d/common-module/utils/index.js';
import { defineEmits, ref, defineExpose, onMounted } from 'vue';
import $moment from 'moment';
import { XlSwitch, XlMessage, XlMessageBox, XlScrollbar } from "@shining3d/ui-components";
import TitleName from '../../components/titleName.vue';
import { XlButton } from '@shining3d/ui-components';
import goodsCard from './components/goodsCard.vue';
import Api from '../../api/case'; 
import { useStore } from "vuex";
import image from '../../assets/image/one.png';
import image1 from '../../assets/image/image14.png';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import { timeMap, unitMap } from './const';
import { $getCdnUrl, formatPrice, convertTimeZone, $timeUnit } from '../../utils/common';
import noData from '../../components/no-data.vue'
import router from '@/router'
import { VueCookieNext } from 'vue-cookie-next';
import _get from 'lodash/get';
// import * as mockData from '../../mock/preference';

const $store = useStore();
const { $t } = useLang("@shining3d/xl-design-order");
const _id =  _get( $store, 'state.factorySelect.id', '' );
const emits = defineEmits(['next', 'clear'])

const typeList = ref([]);
const needSoon = ref( false );
const soonStartTime = ref( '' );
const soonEndTime = ref( '' );
const soonDisabled = ref( false );
const taxRate = ref(0);

const activeTypeItem = ref({}); // 选中的类型
const onTyle = ( item ) => {
    if ( item.productType === activeTypeItem.value.productType ) {
        return;
    }
    // 切换类型
    activeTypeItem.value = item;
    activeCommodity.value = {};
    activeCommodityId.value = '';
    sessionStorage.setItem('detanlDesignChooseGood', '');
    needSoon.value = false;
    soonDisabled.value = false;
    emits('clear');
};

const activeCommodityId = ref(''); // 选中的商品ID
const activeCommodity = ref({}); // 选中的商品
const onGoodsClick = (item) => {
    activeCommodity.value = item;
    activeCommodityId.value = item.productID;
    needSoon.value = false;
    soonDisabled.value = false;
    if ( item.isUrgent ) {
        soonStartTime.value = convertTimeZone(item.receptionStartOn, item.timeZone);
        soonEndTime.value = convertTimeZone(item.receptionEndOn, item.timeZone);
        const nowTime = $moment(new Date(), 'HH:mm');
        let dayOfWeek = $moment().day(); // 0-6，其中0代表周日
        if ( dayOfWeek === 0) {
            dayOfWeek = 7;
        }
        const isInDayTime = nowTime.isBetween($moment(soonStartTime.value, 'HH:mm'), $moment(soonEndTime.value, 'HH:mm'));
        soonDisabled.value = !isInDayTime || !item.receptionTime.includes(dayOfWeek);
    }
    sessionStorage.setItem('detanlDesignChooseGood', activeCommodityId.value);
    hasGetPreferConfig.value = false;
    // 清空后面步骤的信息
    emits('clear');
};

const getValue = () => {
    const { productID, productConfig, skuID, skuName, productConfigName, uploadFileRestrict, toothPositionSelector } = activeCommodity.value;
    
    return {
        activeCommodity, // 选中的商品
        productType: activeTypeItem.value.productType,
        productConfig,
        productName: productConfigName,
        toothPositionSelector,
        productID,
        skuID,
        skuName,
        isUrgent: needSoon.value ? 1 : 0, // 是否加急
        taxRate: taxRate.value,
        // 影像配置文件
        uploadFileRestrict: uploadFileRestrict ? JSON.parse(uploadFileRestrict) : '',
        preferenceConfig: preferenceConfig.value
    }
};
// 机构id
// const institutionId = $store.state.factorySelect.id;
//获取绑定信用卡数量
const bindCardList = ref([]);

const validate = ( needCheckPreferConfig = true ) => {
    // 在点击导航步骤条的时候，如果没有通过点击下一步按钮来获取设计偏好信息，则校验失败
    if (needCheckPreferConfig && !hasGetPreferConfig.value) {
        return {
            valid: false
        }
    }
    return {
        valid: activeCommodityId.value ? true : false,
        message: $t( 'design.case.choose.product' ) || '请选择商品' 
    }; 
};

const preferenceConfig = ref([]);
const hasGetPreferConfig = ref(false);
const btnLoading = ref(false);
const onNext = async () => {
    // 如果没有绑定信用卡，提示去绑定卡
    // if( !$getLocalStorage('hasDefaultCard') ){
    //     XlMessageBox({
    //         title: $t('design.reminder') || '温馨提示',
    //         message: $t('design.case.addCardMessage') || "您尚未绑定信用卡，请至少绑定一张卡后在新建案例",
    //         cancelButtonText: $t( 'design.cancel' ),
    //         confirmButtonText: $t( 'design.confirm' )
    //     }).then(() => {
    //         //跳转机构设置-支付设置
    //         router.push({name: 'institutionSetting', params: { id: institutionId, target: 'payment', showAddCard: true }});
    //     })
    // } else {
        const res = validate( false );
        if ( !res.valid ) {
            XlMessage({
                type: 'warning',
                message: res.message
            });
            return;
        }

        // 获取偏好设计的配置 
        btnLoading.value = true;
        const preResult = await Api.getPreference({
            orgID: _id,
            lang: $lang(),
            productType: activeTypeItem.value.productType,
            productConfig: activeCommodity.value.productConfig
        });
        btnLoading.value = false;
        
        if (preResult && preResult.status === 'success' ) {
            hasGetPreferConfig.value = true;
            preferenceConfig.value = preResult.result || [];
            const data = getValue();
            emits('next', { 
                data: {
                    ...data,
                    preferenceConfig
                },
                index: [0, 1]
            });
        }
    // }
};


onMounted(() => {
    // todo: 获取商品
    Api.fetchProduct({
        orgID: _id,
	    lang: $lang() // 语言
    }).then( res => {
        if ( res && res.status === 'success' ) {
            typeList.value = res.result?.products || [];
            taxRate.value = res.result?.taxRate || 0;
            activeTypeItem.value = typeList.value[0] || {};
        }
    });
});

defineExpose({ getValue, validate })
</script>

<style lang="scss" scoped>
$case-border-color: #E0E4EA;
.case-type-wrap {
    font-family: 'Alibaba PuHuiTi 2.0';
    flex: 1;
    // padding-left: 16px;
    // padding-bottom: 16px;
    // border-radius: 12px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    padding-top: 24px;
    height: 100%;
    box-sizing: border-box;

    .wrap {
        display: flex;
        box-sizing: border-box;
        height: 100%;
        // border-top-left-radius: 12px;
        // border-top-right-radius: 12px;
        flex-direction: column;
        // padding: 0 16px;
        // border-radius: 12px;
    }
    .center {
        padding-left: 16px;
        padding-right: 16px;
        box-sizing: border-box;
        flex: 1;
        display: flex;
        overflow: hidden;
        margin: 0 auto;
        width: 100%;
        .left {
            width: 879px;
            box-sizing: border-box;
            // flex: 1;
            // background: #F7F8FA;
            height: 100%;
            overflow: hidden;
            margin-right: 16px;
            display: flex;
            flex-direction: column;
            flex-shrink: 0;
            // overflow-y: auto;
            :deep(.el-scrollbar__view){
                overflow-x: hidden;
            }
        }
        .right {
            box-sizing: border-box;
            // background: #F7F8FA;
            width: 246px;
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            flex-shrink: 0;
        }
        .types,
        .right {
            .title {
                margin-left: 0px;
            }
        }
        .type-list {
            // display: flex;
            padding-bottom: 8px;
            box-sizing: border-box;
            .item {
                min-width: 208px;
                height: 44px;
                display: inline-flex;
                align-items: center;
                border: 1px solid #F7F8FA;
                background: #F7F8FA;
                border-radius: 6px;
                box-sizing: border-box;
                padding: 0 4px;
                margin-bottom: 8px;
                cursor: pointer;
                margin-right: 10px;
                &:last-child {
                    margin-right: 0px;
                }
            }
            .img-wrap {
                width: 54px;
                height: 36px;
                margin-right: 8px;
                border-radius: 6px;
                overflow: hidden;
            }
            img {
                width: 54px;
                height: 36px;
                vertical-align: inherit;
            }
            .type-name{
                font-size: 16px;
                font-weight: 500;
                font-family: $font-family65;
            }

            .item-active {
                border-color: #5587FF;
                background-color: #EDF3FF;
            }
        }
        .description {
            flex: 1;
            overflow-y: auto;

            .tlt,
            .desc {
                font-size: 14px;
                line-height: 22px;
                color: #737E99;
                font-weight: 400;
            }
            .tlt {
                font-weight: 500;
                font-family: $font-family65;
                margin-bottom: 8px;
                color: #42526E;
            }
            .desc {
                margin-bottom: 24px;
            }
        }
    }
    .center-content  {
        display: flex;
        overflow-x: auto;
        margin: 0 auto;
        // overflow: hidden;
        // min-width: 1136px;
    }

    .content {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        // padding-right: 16px;
    }
    .goods-wrap {
        // flex: 1;
        // overflow: hidden;
        display: flex;
        flex-direction: column;

        .title-desc {
            padding-top: 8px;
        }
    }
    
    .title {
        margin-left: 16px;
    }

    // .desc {
    //     color: #737E99;
    //     font-size: 14px;
    //     line-height: 22px;
    //     margin-bottom: 24px;
    //     margin-left: 16px;
    //     margin-right: 16px;
    // }

    .goods-list {
        flex: 1;
        overflow-y: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .footer {
        margin-right: 16px;
        box-sizing: border-box;
        height: 68px;
        display: flex;
        border-top: 1px solid $case-border-color;
        align-items: center;

        .urgent-wrap {
            flex: 1;
            height: 100%;
            font-size: 14px;
            padding-left: 16px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .soon-wrap {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding-right: 28px;
                .iconfont {
                    color: #A5ACBE;
                }
                .tlt {
                    padding-left: 8px;
                    padding-right: 4px;
                }
                .urgent-tip{
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 22px;
                    color: #42526E;
                }
            }

            .detail {
                display: flex;
                justify-content: flex-end;
                .item {
                    color: #A5ACBE;
                    margin-right: 24px;
                    &:last-child {
                        margin-right: 28px;
                    }
                }
                .tlt {
                    padding-right: 8px;
                }
                .value {
                    color: #42526E;
                }
            }
        }
    }
}
@media screen and (min-width: 1614px) {
    .case-type-wrap {
        .center {
            .left {
                width: 1171px !important;
            }
        }
    }
}
</style>